import type React from 'react';

import type { SendOrderStatus } from '@change-corgi/middle-end-gql-schema';

import { Link } from '#src/app/shared/components/adminShadcn';

import { useResultsLinks } from './hooks/useResultsLinks';

export const ResultsLinks: React.FC<{
	id: string;
	status: SendOrderStatus;
	messageType: { readonly id: string; readonly name: string; readonly type: string };
	createdAt: string;
	sendAtLocalized: string | null;
	hideDash?: boolean;
}> = ({ id, status, sendAtLocalized, createdAt, messageType, hideDash = false }) => {
	const {
		data: { isDataAfterRollout, dashboardCorgiBetaLink, redashDashboardLink, resultsChartioLink },
	} = useResultsLinks({ createdAt, id, messageType });

	if (status === 'DRAFT') {
		return <span>Unavailable</span>;
	}

	if (status === 'SCHEDULED') {
		return <span>Scheduled for: {sendAtLocalized || '<MISSING SEND DATE>'}</span>;
	}

	if (isDataAfterRollout) {
		return (
			<>
				{!redashDashboardLink ? (
					<span>Unavailable</span>
				) : (
					<Link target="_blank" to={redashDashboardLink}>
						Redash
					</Link>
				)}
				{!hideDash && (
					<>
						{' / '}
						<Link target="_blank" to={dashboardCorgiBetaLink}>
							Dash(beta)
						</Link>
					</>
				)}
			</>
		);
	}

	return (
		<Link target="_blank" to={resultsChartioLink}>
			View Results
		</Link>
	);
};
